export const CHALLENGE_STATS_USER_TASKS_REQUEST = "CHALLENGE_STATS_USER_TASKS_REQUEST"
export const CHALLENGE_STATS_USER_TASKS_CLEAR = "CHALLENGE_STATS_USER_TASKS_CLEAR"
export const CHALLENGE_STATS_USER_TASKS_SUCCESS = "CHALLENGE_STATS_USER_TASKS_SUCCESS"
export const CHALLENGE_STATS_USER_TASKS_ERROR = "CHALLENGE_STATS_USER_TASKS_ERROR"
export const CHALLENGE_STATS_USER_TASKS_FILTER_SET = "CHALLENGE_STATS_USERS_FILTER_SET"
export const CHALLENGE_STATS_USER_TASKS_COMPLETED_TOGGLE = "CHALLENGE_STATS_USER_TASKS_COMPLETED_TOGGLE"
